<template>
  <div>
    <div class="container module-wrapper">
    <ul id="ul2">
      <li v-for="item in posts" class="gutter-14__li grid-4" style="padding-bottom: 3%;padding-left:0px">
        <div class="basic-card" style="border:0px;">
          <a :href="getUrl(item.id, item.sendPortal)" class="basic-card-img-link">
          <div class="background-image basic-card__img" :style="{'background-image': 'url(' + getImageUrl(item.imageUrl, item.sendPortal) + ')'}" style="width: 100%; background-size: cover;">
            <p class="alt-text">{{item.title}}</p>
          </div>
          </a>
          <a :href="getUrl(item.id, item.sendPortal)" class="square-box__title__link2" style="height: 43px; overflow: hidden;"
          v-if="item.sendPortal === 'CONFIRM'">[{{item.portalOrgName}}]{{item.title}}</a>
          <a :href="getUrl(item.id, item.sendPortal)" class="square-box__title__link2" style="height: 43px; overflow: hidden;"
          v-if="item.sendPortal !== 'CONFIRM'">{{item.title}}</a>
          <p class="square-box__date2">{{item.createdDate.substring(0, 10)}}</p>
        </div>
      </li>
    </ul>
    </div>
    <div v-if="currentPage !== totalPages" class="show-more-wrapper">
      <button class="more-btn btn--blue-line" id="moreBtn" @click="getNextPage()" title="최신글 더보기">
        더보기
        <span class="more-btn__plugs-icon">+</span>
      </button>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'portal-home-post',
    props: ['initData', 'totalPages'],
    data() {
      return {
        posts: this.initData,
        progressing: false,
        currentPage: 1,
        size: 6,
      };
    },
    methods: {
      getImageUrl(photoUrl, sendPortal) {
        let imageUrl = '';
        if (sendPortal === 'NONE' || sendPortal === 'CONFIRM') {
          imageUrl = photoUrl || '/images/homepage/berry.jpg';
        } else if (sendPortal === 'MENTORING') {
          imageUrl = photoUrl || '/images/default-image-mentoring.jpg';
        } else if (sendPortal === 'COUNSEL') {
          imageUrl = photoUrl || '/images/default-image-counsel.jpg';
        } else {
          imageUrl = photoUrl || '/images/default-image-tip.jpg';
        }
        return imageUrl;
      },
      getUrl(id, sendPortal) {
        let url = '';
        if (sendPortal === 'NONE' || sendPortal === 'CONFIRM') {
          url = `/fpp/detail.do?id=${id}`;
        } else {
          url = `/fpp/view.do?id=${id}&page=1`;
        }
        return url;
      },
      getNextPage() {
        if (this.currentPage >= this.totalPages) return;
        this.currentPage += 1;
        this.progressing = true;
        axios.get('/api/portal-posts', { params: { page: this.currentPage } }).then((res) => {
          this.progressing = false;
          const posts = res.data || [];
          this.posts.push(...posts);
        }).catch(e => console.log(e));
        const moreBtnCon = document.getElementById('moreBtn');
        moreBtnCon.scrollIntoView();
      },
    },
  };
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// PortalHomePost.vue?6d2f9d78